import { icon } from '../icons';
import { t } from './i18n';

export const TRIAL_NOTICE_PENDING_KEY = 'rc_trial_notice_pending';

export function markTrialNoticePending(): void {
  localStorage.setItem(TRIAL_NOTICE_PENDING_KEY, '1');
}

function isDashboardPath(): boolean {
  return window.location.pathname.replace(/\/+$/, '') === '/dashboard';
}

function closeTrialNotice(overlay: HTMLElement): void {
  localStorage.removeItem(TRIAL_NOTICE_PENDING_KEY);
  overlay.remove();
}

function showTrialNotice(): void {
  if (!isDashboardPath() || localStorage.getItem(TRIAL_NOTICE_PENDING_KEY) !== '1') {
    return;
  }

  if (document.querySelector('.trial-notice')) {
    return;
  }

  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal trial-notice" role="dialog" aria-modal="true" aria-labelledby="trial-notice-title">
      <div class="trial-notice-icon">
        ${icon('sparkles', { size: 32, attrs: 'aria-hidden="true"' })}
      </div>
      <div class="modal-header">
        <div>
          <h2 id="trial-notice-title">${t('trialNotice.title')}</h2>
          <p class="modal-subtitle">${t('trialNotice.subtitle')}</p>
        </div>
        <button type="button" class="modal-close" data-action="close" aria-label="${t('common.close')}">
          ${icon('x', { size: 18 })}
        </button>
      </div>
      <p class="trial-notice-body">${t('trialNotice.body')}</p>
      <div class="modal-actions">
        <button type="button" class="btn btn-primary" data-action="close">${t('trialNotice.confirm')}</button>
      </div>
    </div>
  `;

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) {
      closeTrialNotice(overlay);
    }
  });

  overlay.querySelectorAll('[data-action="close"]').forEach((button) => {
    button.addEventListener('click', () => closeTrialNotice(overlay));
  });

  document.addEventListener('keydown', function handler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      document.removeEventListener('keydown', handler);
      closeTrialNotice(overlay);
    }
  });

  document.body.appendChild(overlay);
  (overlay.querySelector('[data-action="close"]') as HTMLElement | null)?.focus();
}

function initTrialNotice(): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showTrialNotice, { once: true });
    return;
  }

  queueMicrotask(showTrialNotice);
}

initTrialNotice();
